import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import { HomeAppContext } from "../Home";
import api from "../../Services/api";
import { errorManagement } from "../../Services/errorManagement";
import Form, { AIEngineFormMode } from "./Form";
import GenericDialog from "../GenericDialog";

const initialEntry = {
  engineName: "",
  apiUrl: "",
  apiToken: "",
  description: "",
  isAvailableToTeam: false,
  isActive: false,
  isDefault: false,
  isAssistant: false,
  apiCost: 0,
  engineFamily: "",
  engineGroup: "",
  maxTokens: 0,
  maxCalls: 0,
  temperature: 0.0
};

export default function Create({ open, setOpen, onCreate }) {
  const { homeDispatch } = useContext(HomeAppContext);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [connectionNeedsTested, setConnectionNeedsTested] = useState(true);
  const [familiesFromApi, setFamiliesFromApi] = useState([]);
  const [groupsFromApi, setGroupsFromApi] = useState([]);

  React.useEffect(() => {
    if (open) {
      setSubmitted(false);
      setErrors([]);
      setInternalEntry(initialEntry);
      setLoading(false);
      setConnectionNeedsTested(true);
      getEngineFamilies();
      getEngineGroups();
    } else {
      setInternalEntry(null);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };

  const handleTestConnection = () => {
    const testDto = {
      engineName: internalEntry.engineName,
      apiUrl: internalEntry.apiUrl,
      apiToken: internalEntry.apiToken,
      engineFamily: internalEntry.engineFamily
    };
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Testing AI Engine connection", loading: true }
    });
    api
      .post("/api/ai-engines/test-connection", testDto)
      .then((r) => {
        if (r.data) {
          homeDispatch({
            type: "NOTIFICATION",
            data: {
              message: "Testing AI Engine connection success",
              type: "success"
            }
          });
          setConnectionNeedsTested(false);
        }
      })
      .catch((error) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message:
              "Testing AI Engine connection failed: " + error.response.data,
            type: "error"
          }
        });
      });
  };

  const handleCloseSave = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Saving AI Engine", loading: true }
    });
    setSubmitted(true);
    setLoading(true);
    const newEngine = {
      engineName: internalEntry.engineName,
      apiUrl: internalEntry.apiUrl,
      apiToken: internalEntry.apiToken,
      description: internalEntry.description,
      isAvailableToTeam: internalEntry.isAvailableToTeam,
      isActive: internalEntry.isActive,
      isDefault: internalEntry.isDefault,
      isAssistant: internalEntry.isAssistant,
      apiCost: internalEntry.apiCost,
      engineFamily: internalEntry.engineFamily,
      temperature: internalEntry.temperature,
      engineGroup: internalEntry.engineGroup,
      maxTokens: internalEntry.maxTokens,
      maxCalls: internalEntry.maxCalls
    };
    api
      .post(`/api/ai-engines`, newEngine)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Saved AI Engine " + response.data.engineName,
            type: "success"
          }
        });
        setOpen(false);
        setLoading(false);
        onCreate();
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };

  const getEngineFamilies = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Fetching engine families", loading: true }
    });
    api
      .get("/api/ai-engines/family/dropdown")
      .then((r) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Engine families fetched successfuly",
            type: "success"
          }
        });
        setFamiliesFromApi(r.data);
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  };

  const getEngineGroups = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Fetching engine groups", loading: true }
    });
    api
      .get("/api/ai-prompts/group/dropdown")
      .then((r) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Engine groups fetched successfuly",
            type: "success"
          }
        });
        setGroupsFromApi(r.data);
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  };
  const actions = (
    <>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      {connectionNeedsTested === true ? (
        <Button
          onClick={handleTestConnection}
          variant="outlined"
          color="primary"
        >
          Test Connection
        </Button>
      ) : (
        <Button
          onClick={handleCloseSave}
          color="primary"
          variant="outlined"
          autoFocus
          disabled={loading || saveDisabled}
        >
          Save Engine
        </Button>
      )}
    </>
  )
  return internalEntry === null ? null : (
    <GenericDialog
      maxWidth={"md"}
      open={open}
      onClose={handleClose}
      title={"New AI Engine"}
      actions={actions}
    >
        <Form
          mode={AIEngineFormMode.NEW}
          entity={internalEntry}
          errors={errors}
          setEntity={setInternalEntry}
          loading={loading}
          submitted={submitted}
          setSaveDisabled={setSaveDisabled}
          engineFamilies={familiesFromApi}
          engineGroups={groupsFromApi}
        />
    </GenericDialog>
  );
}
